function NXPlugin({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1274)">
        <path
          d="M13.1428 1.32161V9.5359H18.8928L9.85712 22.6788V14.4645H4.10712L13.1428 1.32161Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1274">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500183)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXPlugin;
